import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var JoystickAlt = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    fill: "none",
    d: "M15 7H9c-2.753 0-4.997 2.247-5 5.009A5.006 5.006 0 009 17h6a5.007 5.007 0 005-4.994C19.996 9.247 17.754 7 15 7zm-3 6h-2v2H8v-2H6v-2h2V9h2v2h2v2zm3 1a1 1 0 110-2 1 1 0 110 2zm2-2a1 1 0 110-2 1 1 0 110 2z",
    key: "k0"
  }), React.createElement("circle", {
    cx: 15,
    cy: 13,
    r: 1,
    key: "k1"
  }), React.createElement("circle", {
    cx: 17,
    cy: 11,
    r: 1,
    key: "k2"
  }), React.createElement("path", {
    d: "M10 9H8v2H6v2h2v2h2v-2h2v-2h-2z",
    key: "k3"
  }), React.createElement("path", {
    d: "M15 5H9c-3.848 0-6.984 3.132-7 6.988v.038C2.014 15.873 5.151 19 9 19h6c3.854 0 6.995-3.136 7-6.994v-.001V12v-.01C21.985 8.134 18.85 5 15 5zm0 12H9a5.006 5.006 0 01-5-4.991C4.003 9.247 6.247 7 9 7h6c2.754 0 4.996 2.247 5 5.006A5.007 5.007 0 0115 17z",
    key: "k4"
  }));
});
JoystickAlt.displayName = 'JoystickAlt';
export var JoystickAltDimensions = {
  height: 24,
  width: 24
};